import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { ExpenseModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { ExpenseBO } from './expense.bo';

@Repository({
    boType: ExpenseBO,
    apiController: TaggedUrl.join('purchase/expenseNames', [Tags.Api])
})
export class ExpenseRepositoryBase extends RepositoryBase<ExpenseBO, ExpenseModel> {
    public constructor(
        private weaver: Weaver,
        http: HttpService) {
        super(http);
    }

    protected createBO(): ExpenseBO {
        return new ExpenseBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: ExpenseModel) {
        return {
            id: model.id,
            version: model.version,
            name: model.name
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<ExpenseModel> {
        return new ExpenseModel(pickBy({
            id: item.id,
            version: item.version,
            name: item.name,
        }, val => val !== void 0));
    }
}
